import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { Branch, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { take } from "rxjs/operators";
import { InvDailyWarehouse } from "../model/inv-daily-warehouse.model";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import * as moment from "moment";

@Component({
  selector: "ngx-inv-daily-warehouse",
  templateUrl: "./inv-daily-warehouse.component.html",
  styleUrls: ["./inv-daily-warehouse.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvDailyWarehouseComponent extends BaseFormComponent<InvDailyWarehouse> {
  itemColumns: form_control[] = [];
  dataList: InvDailyWarehouse[] = [];
  BranchLookUp: Branch[];
  DateNow: string;

  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private splashFormService: SplashFormService,
    __id: FormContainerModel,
    _tabsservice: TabularService
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.tabsservice = _tabsservice;
  }

  async ngOnInit() {
    this.apiName = "InvDailyHeader/GetWarehouseStockColumns";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.Pages.PageMenu.InvDailyWarehouse");
    const m = moment();
    this.DateNow = m.locale("fa").format("YYYY/MM/DD");
    this.getItemColumns();
    await this.FillData();
    super.ngOnInit();
  }

  async FillData() {
    const data = await (<Promise<Branch[]>>this.httpCommonService.getList("Branch").pipe(take(1)).toPromise());
    if (this.isMultiBranch) this.BranchLookUp = data.filter((x) => !x.AccessToAllBranches && x.IsActive);
    else this.BranchLookUp = data.filter((x) => x.Id == this.accountService.authService.currentBranchId);
  }

  setdefault(): void {
    if (!this.model.VoucherDate) this.model.VoucherDate = this.DateNow as any;
    if (!this.isMultiBranch) this.model.BranchId = this.accountService.authService.currentBranch?.Id;
  }

  addControl(): void {
    this.setValue("VoucherDate", this.model.VoucherDate);
    this.setValue("BranchId", this.model.BranchId);
    if (!this.isMultiBranch) this.formGroup.controls["BranchId"].disable();
  }

  getItemColumns(): void {
    this.httpCommonService
      .get<form_control[]>("InvDailyHeader/GetWarehouseStockColumns")
      .pipe(take(1))
      .subscribe((res) => {
        this.itemColumns = res;
        this.cd.markForCheck();
      });
  }

  loadItems() {
    const controls = this.formGroup.controls;
    if (controls["VoucherDate"].value && controls["BranchId"].value) {
      this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Inv.DailyWarehouse.GettingInformation"));
      const date = new Date(controls["VoucherDate"].value.setHours(23, 59, 59, 999)).toISOString();
      this.httpCommonService
        .get<any>("InvDailyHeader/GetWarehouseStockItems?date=" + date + "&branchId=" + controls["BranchId"].value)
        .pipe(take(1))
        .subscribe(
          (res: InvDailyWarehouse[]) => {
            this.dataList = res.filter((x) => x.EntryAmount > 0 || x.PrevRemainAmount);
            this.splashFormService.closeLoading();
            this.cd.markForCheck();
          },
          (err) => {
            let message = Utilities.getHttpResponseMessage(err);
            this.sts.showDialog(`${message}`, this.translate("ClientApp.FrontOffice.Inv.DailyWarehouse.ErrorMessage"));
            this.splashFormService.closeLoading();
          }
        );
    }
  }
}
